
document.addEventListener("DOMContentLoaded", function(event) { 
  
  
  jQuery('.faq > li').each(
    (i,o) => {
    	
      	let $li = jQuery(o);
      
      	jQuery(o).click(
          e => {
            $li.toggleClass('active');
          }
        );
      
    }
  );
  
	return;
  const desktop = true;
  var acc = $('.faq h3');
  var panel = $('.faq div');

  for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function() {
          var setClasses = !this.classList.contains('active');
          setClass(acc, 'active', 'remove');
          setClass(panel, 'show', 'remove');

          if (setClasses) {
              this.classList.toggle("active");
              this.nextElementSibling.classList.toggle("show");
          }
      }
      
      
      if(window.innerWidth >= 980){
        acc[i].classList.toggle("active");
      	acc[i].nextElementSibling.classList.toggle("show");
      }
      
      
  }

  function setClass(els, className, fnName) {
      for (var i = 0; i < els.length; i++) {
          els[i].classList[fnName](className);
      }
  }

});
  
 
